var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-data-table',{attrs:{"dense":"","headers":_vm.changesHistoryHeaders,"items":_vm.changesHistoryTableData,"must-sort":"","sort-desc":"","data-cy":"changes-history-table"},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.formatDate(item.date))+" "+_vm._s(_vm.formatTime(item.date)))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }